import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { base64logo, base64watermark } from "./BaseImages";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

// Definir los estilos
const styles = StyleSheet.create({
  page: {
    // color: "#454546",
    // height: "100%",
    // margin: 20,
    padding: 0,
    // color: "#333",
    height: "100%",
    paddingBottom: 50,
    fontSize: 12,
    color: "#000",
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 40,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "Roboto",
    color: "#000",
    marginBottom: 20,
  },
  companyInfo: {
    textAlign: "center",
    paddingHorizontal: 40,
    marginBottom: 20,
    fontSize: 10,
  },
  textBold: {
    color: "#000",
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: 700,
    width: "48%", // two items per row, with some space between
  },

  logo: {
    width: "auto",
    height: 64, // Reduce from 64 to 50
  },

  // Update the headerright style
  headerright: {
    width: "auto",
    height: 45, // Reduce from 25% to 10%
  },
  section: {
    paddingHorizontal: 10,
    marginBottom: 10,
  },

  text: {
    marginBottom: 5,
    fontSize: 10,
    fontFamily: "Roboto",
  },
  footerImage: {
    width: "100%",
    height: "8%",
    position: "absolute",
    bottom: 0,
    zIndex: -1, // Añadido para asegurar que esté detrás de otros elementos
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.04,
    zIndex: "-10",
  },
  gridContainer: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 50,
    marginBottom: 20,
    fontSize: 12,
  },

  gridContainerTotal: {
    // width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 50,
    marginBottom: 20,
    fontSize: 12,
  },

  gridItemTitle: {
    width: "48%", // two items per row, with some space between
    paddingBottom: 5,
    fontSize: 12,
    fontFamily: "Roboto",
    fontWeight: 1000,
    // borderBottom: "1px solid #000",
    // borderTop: "1px solid #000",
    // borderLeft: "1px solid #000",
    // borderRight: "1px solid #000",
  },
  gridItem: {
    width: "48%", // two items per row, with some space between
    marginBottom: 5,
    fontSize: 12,
  },
  singleItem: {
    width: "100%",
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  firmas: {
    marginTop: 40,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 20,
    position: "absolute",
    bottom: 20,
  },
  colum: {
    flex: 1,
    textAlign: "center",
    fontSize: 12,
    marginTop: 50, // Adjusted to align with the footer
    // Remove marginTop: 60 which is causing the misalignment
  },
  columDr: {
    flex: 1,
    textAlign: "center",
    marginLeft: 20,
    marginBottom: 50,
  },
  firma: {
    width: 90,
    marginLeft: "35%",
    height: 50,
  },
});

const PaymentPdf = ({ data }) => {
  return (
    <Document>
      <Page style={styles.page}>
        <Image fixed style={styles.watermark} src="/images/watermark.jpg" />
        <View fixed style={styles.header}>
          <Image style={styles.logo} src="/images/logoderecho.jpg" />
          <Image style={styles.headerright} src="/images/headerright.png" />
        </View>
        {/* Title */}
        <Text style={styles.title}>RECIBO PAGO</Text>

        {/* Patient Information */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Fecha:</Text> {data?.fecha}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Telefono:</Text> {data?.telefono}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Recibi de:</Text> {data?.nombre}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Metodo de pago:</Text>{" "}
              {data?.metodo}
            </Text>
          </View>
        </View>

        {/* Receta Details */}
        <View style={styles.section}>
          <View style={styles.gridContainer}>
            <Text style={styles.gridItemTitle}>Descripcion</Text>
            <Text style={styles.gridItemTitle}>Monto</Text>
          </View>
          <View style={styles.gridContainer}>
            <Text style={styles.gridItem}>{data?.motivo}</Text>
            <Text style={styles.gridItem}>Bs. {data?.monto}</Text>
          </View>
        </View>

        {/* Total */}
        <View style={styles.gridContainerTotal}>
          <Text style={styles.text}>
            <Text style={styles.textBold}>Total en letras:</Text>{" "}
            {data?.monto_literal}
          </Text>
          <Text style={styles.text}>
            <Text style={styles.textBold}>Total:</Text> Bs. {data?.monto}
          </Text>
        </View>
        <View style={styles.gridContainerTotal}>
          <Text style={styles.text}>
            <Text style={styles.textBold}></Text>
          </Text>
          <Text style={styles.text}>
            <Text style={styles.textBold}>Saldo:</Text> Bs. {data?.saldo}
          </Text>
        </View>

        {/* Firmas */}
        <View style={styles.firmas}>
          <View style={styles.columDr}>
            <Image style={styles.firma} src="/images/firma.png" />
            <Text style={styles.text}>______________________</Text>
            <Text style={styles.text}>{data?.doctor?.printer_name}</Text>
            <Text style={styles.text}>{data?.doctor?.specialty}</Text>
          </View>
          <View style={styles.colum}>
            <Text style={styles.text}>______________________</Text>
            <Text style={styles.text}>Entregue Conforme</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default PaymentPdf;
